import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.scss';
import "bootstrap/dist/css/bootstrap.min.css";
import "react-step-progress-bar/styles.css";
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


